// Tema de marca de TurnLink — fuente única de verdad para landing, superadmin y
// registro (el panel del negocio NO lo usa: ahí manda el color de cada negocio).
//
// Es la paleta del perfil de marca decidido para la campaña (vault:
// turnlink/campana-instagram.md, plan §1-ter): los colores reales del logo
// (el bot en la burbuja con el badge de calendario azul) sobre un fondo salvia
// claro, no blanco puro. Un solo acento (el verde del logo); el azul aparece
// nada más en señales de calendario/agenda, como en el propio logo.
// Las llaves se conservan del tema oscuro anterior para no tocar a los
// consumidores; lo que cambia son los valores (tema claro).
export const BRANDING_THEME = {
  // Verde del logo: CTA, links, acentos, la "link" del wordmark.
  primary: {
    main: '#439C54',
    light: '#5FB36F',
    dark: '#2D5A44',   // greenInk: hover del CTA y texto verde con contraste
    lighter: '#DCEFDF',
    tint: 'rgba(67, 156, 84, 0.12)',
  },

  // Azul del badge de calendario: solo para señales de agenda/sincronización.
  accent: {
    main: '#2985F0',
    light: '#5AA3F5',
    dark: '#1C6FD0',
    lighter: '#E3EFFD',
    tint: 'rgba(41, 133, 240, 0.10)',
  },

  // Superficies: salvia clara de fondo, blanco para tarjetas.
  backgrounds: {
    primary: '#EFF6F1',   // salvia clara (fondo de página)
    secondary: '#FFFFFF', // tarjetas / paneles
    tertiary: '#E4EEE7',  // hover, superficie hundida
    light: '#F7FBF8',     // salvia casi blanca (franjas alternas)
  },

  // Texto: tinta cálida y grises con el mismo matiz.
  text: {
    primary: '#16140F',   // tinta
    secondary: '#56605A', // secundario (≥ 6:1 sobre salvia)
    muted: '#7A766E',     // gris de marca: notas, pies, labels
    dark: '#16140F',
  },

  // Semánticos (desaturados para convivir con la salvia).
  success: '#439C54',
  error: '#C75D5D',   // rojo alerta propuesto en la campaña (pilar "dolor")
  warning: '#B7791F',
  info: '#2985F0',

  // Gradientes contenidos: el CTA es casi sólido, el "subtle" es la salvia.
  gradients: {
    primary: 'linear-gradient(135deg, #4AA65B 0%, #3F9450 100%)',
    accent: 'linear-gradient(135deg, #2985F0 0%, #1C6FD0 100%)',
    mixed: 'linear-gradient(135deg, #2985F0 0%, #439C54 100%)',
    subtle: 'linear-gradient(160deg, #EFF6F1 0%, #E7F1EA 100%)',
  },

  // Sombras teñidas con el verde oscuro (nunca negro puro sobre fondo claro).
  shadows: {
    sm: '0 1px 2px 0 rgba(45, 90, 68, 0.08)',
    md: '0 6px 16px 0 rgba(45, 90, 68, 0.10)',
    lg: '0 16px 40px 0 rgba(45, 90, 68, 0.14)',
    xl: '0 28px 60px 0 rgba(45, 90, 68, 0.18)',
    glow: '0 10px 30px rgba(67, 156, 84, 0.28)',
  },

  // Hairlines: tinta a baja opacidad.
  borders: {
    light: 'rgba(22, 20, 15, 0.08)',
    medium: 'rgba(22, 20, 15, 0.14)',
    dark: 'rgba(22, 20, 15, 0.22)',
  },
};

export const getColor = (path) => {
  return path.split('.').reduce((obj, key) => obj?.[key], BRANDING_THEME);
};
